import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants';
import {NatGetAreaCode} from './NatGetAreaCode';
import {NatPostAreaCode, NatPostAreaCodeParams} from './NatPostAreaCode';
import {NatPutAreaCode, NatPutAreaCodeParams} from './NatPutAreaCode';
import {NatDeleteAreaCode} from './NatDeleteAreaCode';
import {SortOrder} from '../../../../components/shared/SortOrder';
import {NatGetAreaCodeList, SearchCondition, SearchConditionPageInfo} from './NatGetAreaCodeList';

export default class NatAreaCodeRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 地域コード取得
    async getAreaCode(areaId: number): Promise<NatGetAreaCode> {
        return await this.http.get(`/api/admin/areaCode/${areaId}`);
    }

    // 地域コード新規登録
    async postAreaCode(request: NatPostAreaCodeParams): Promise<NatPostAreaCode> {
        return await this.http.post(`/api/admin/areaCode`, {
                areaCode: request.areaCode,
                areaName: request.areaName,
                contactMailAddress: request.contactMailAddress,
            }, ContentType.JSON,
        )
    }

    // 地域コード更新
    async putAreaCode(areaId: number, requestParam: NatPutAreaCodeParams): Promise<NatPutAreaCode> {
        return await this.http.put(`/api/admin/areaCode/${areaId}`, requestParam)
    }

    // 地域コード削除
    async deleteAreaCode(areaId: number): Promise<NatDeleteAreaCode> {
        return await this.http.delete(`/api/admin/areaCode/${areaId}`);
    }

    // 地域コード一覧取得
    async getAreaCodeList(
        searchCondition?: SearchCondition,
        searchConditionPageInfo?: SearchConditionPageInfo,
        searchConditionSortInfos?: SortOrder[],
    ): Promise<NatGetAreaCodeList> {
        const sortInfos: string[] = []
        if (searchConditionSortInfos) {
            searchConditionSortInfos.forEach((sortInfo) => {
                sortInfos.push(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
            })
        }
        return await this.http.post(`/api/admin/areaCodeList`, {
                areaCode: searchCondition && searchCondition.areaCode ?
                    searchCondition.areaCode : null,
                areaName: searchCondition && searchCondition.areaName ?
                    searchCondition.areaName : null,
                contactMailAddress: searchCondition && searchCondition.contactMailAddress ?
                    searchCondition.contactMailAddress : null,
                sortInfo: sortInfos,
                pageNum: searchConditionPageInfo && searchConditionPageInfo.pageNum ?
                    searchConditionPageInfo.pageNum: null,
                page: searchConditionPageInfo && searchConditionPageInfo.page ?
                    searchConditionPageInfo.page: null
            }, ContentType.JSON,
        )
    }
}
